(function () {
  var ATTRIBUTION_STORAGE_KEY = 'kiki_nightwear_attribution_v1';
  var LEAD_SUCCESS_QUERY_KEY = 'fc';
  var LEAD_SUCCESS_QUERY_VALUE = 'success';
  var ATTRIBUTION_QUERY_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'twclid',
    'gclid',
    'fbclid',
    'ttclid',
    'msclkid'
  ];

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function clampString(value, maxLength) {
    var stringValue = String(value == null ? '' : value).trim();
    if (!maxLength || stringValue.length <= maxLength) return stringValue;
    return stringValue.slice(0, maxLength);
  }

  function parseJsonSafe(raw) {
    if (!raw) return {};
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function readStoredAttribution() {
    var fromSession = {};
    var fromLocal = {};

    try {
      fromSession = parseJsonSafe(window.sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY));
    } catch (error) {
      fromSession = {};
    }

    try {
      fromLocal = parseJsonSafe(window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY));
    } catch (error) {
      fromLocal = {};
    }

    var merged = {};
    [fromLocal, fromSession].forEach(function (source) {
      Object.keys(source || {}).forEach(function (key) {
        var value = clampString(source[key], 900);
        if (value) merged[key] = value;
      });
    });

    return merged;
  }

  function writeStoredAttribution(payload) {
    var serialized = '';
    try {
      serialized = JSON.stringify(payload || {});
    } catch (error) {
      return;
    }

    try {
      window.sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, serialized);
    } catch (error) {
      return null;
    }

    try {
      window.localStorage.setItem(ATTRIBUTION_STORAGE_KEY, serialized);
    } catch (error) {
      return null;
    }
  }

  function collectAttribution(voteSource) {
    var stored = readStoredAttribution();
    var attribution = {};

    Object.keys(stored).forEach(function (key) {
      var nextValue = clampString(stored[key], 900);
      if (nextValue) attribution[key] = nextValue;
    });

    var params = null;
    var hasCampaignQuery = false;

    try {
      params = new URLSearchParams(window.location.search || '');
    } catch (error) {
      params = null;
    }

    if (params) {
      ATTRIBUTION_QUERY_KEYS.forEach(function (key) {
        var value = clampString(params.get(key), 220);
        if (!value) return;
        attribution[key] = value;
        hasCampaignQuery = true;
      });
    }

    var pathWithQuery = '/';
    var href = '';
    var referrer = '';

    try {
      pathWithQuery = clampString((window.location.pathname || '/') + (window.location.search || ''), 700);
      href = clampString(window.location.href || '', 900);
      referrer = clampString(document.referrer || '', 900);
    } catch (error) {
      pathWithQuery = '/';
      href = '';
      referrer = '';
    }

    if (hasCampaignQuery || !attribution.landing_path) {
      attribution.landing_path = pathWithQuery;
    }

    if (hasCampaignQuery || !attribution.landing_url) {
      attribution.landing_url = href;
    }

    attribution.page_path = pathWithQuery;

    if (referrer && !attribution.referrer) {
      attribution.referrer = referrer;
    }

    if (voteSource) {
      attribution.source = clampString(voteSource, 80);
    }

    writeStoredAttribution(attribution);
    return attribution;
  }

  function emitTrackingEvent(name, detail) {
    if (!name) return;
    var payload = Object.assign(
      {
        event: name,
        timestamp: new Date().toISOString()
      },
      detail || {}
    );

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (error) {
      // no-op
    }

    try {
      window.dispatchEvent(new CustomEvent(name, { detail: payload }));
    } catch (error) {
      // no-op
    }

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (error) {
      // no-op
    }
  }

  function markLeadSuccessInUrl() {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get(LEAD_SUCCESS_QUERY_KEY) === LEAD_SUCCESS_QUERY_VALUE) {
        return;
      }
      url.searchParams.set(LEAD_SUCCESS_QUERY_KEY, LEAD_SUCCESS_QUERY_VALUE);
      window.location.replace(url.toString());
    } catch (error) {
      // no-op
    }
  }

  function hasLeadSuccessInUrl() {
    try {
      var url = new URL(window.location.href);
      return url.searchParams.get(LEAD_SUCCESS_QUERY_KEY) === LEAD_SUCCESS_QUERY_VALUE;
    } catch (error) {
      return false;
    }
  }

  function clearLeadSuccessQueryFromUrl() {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get(LEAD_SUCCESS_QUERY_KEY) !== LEAD_SUCCESS_QUERY_VALUE) {
        return;
      }
      url.searchParams.delete(LEAD_SUCCESS_QUERY_KEY);
      var next =
        url.pathname +
        (url.search ? url.search : '') +
        (url.hash ? url.hash : '');
      window.history.replaceState({}, document.title, next);
    } catch (error) {
      // no-op
    }
  }

  function readNumber(value, fallback) {
    var num = Number(value);
    if (Number.isFinite(num)) return num;
    return fallback;
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function generateConversionId(seed) {
    var suffix = String(seed || '').slice(0, 20).replace(/[^a-z0-9_-]/gi, '');

    try {
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        var hex = Array.prototype.map
          .call(bytes, function (byte) {
            return byte.toString(16).padStart(2, '0');
          })
          .join('');
        return suffix ? hex + '-' + suffix : hex;
      }
    } catch (error) {
      // no-op
    }

    var fallback = (Date.now().toString(36) + Math.random().toString(36).slice(2)).slice(0, 24);
    return suffix ? fallback + '-' + suffix : fallback;
  }

  function readProgress(card) {
    return readNumber(card.getAttribute('data-look-progress'), 0);
  }

  function readVotes(card) {
    return readNumber(card.getAttribute('data-look-votes'), 0);
  }

  function setProgress(card, nextValue) {
    var safeValue = Math.max(0, Math.min(100, Math.round(readNumber(nextValue, 0))));
    card.setAttribute('data-look-progress', String(safeValue));

    var valueNode = card.querySelector('[data-progress-value]');
    if (valueNode) {
      valueNode.textContent = String(safeValue);
    }

    var fillNode = card.querySelector('.nw-progress__fill');
    if (fillNode) {
      fillNode.style.setProperty('--nw-progress', safeValue + '%');
    }
  }

  function setVotes(card, nextValue) {
    var safeValue = Math.max(0, Math.round(readNumber(nextValue, 0)));
    card.setAttribute('data-look-votes', String(safeValue));
  }

  function compareRankedCards(a, b, leaderKey) {
    var votesDiff = readVotes(b) - readVotes(a);
    if (votesDiff !== 0) return votesDiff;

    var aKey = a.getAttribute('data-look-key') || '';
    var bKey = b.getAttribute('data-look-key') || '';
    if (leaderKey) {
      var aIsLeader = aKey === leaderKey;
      var bIsLeader = bKey === leaderKey;
      if (aIsLeader !== bIsLeader) {
        return aIsLeader ? -1 : 1;
      }
    }

    var progressDiff = readProgress(b) - readProgress(a);
    if (progressDiff !== 0) return progressDiff;

    var keyOrder = {
      helix: 0,
      'contour-set': 1,
      'signature-slip': 2,
      'v-lace-set': 3
    };
    var aPriority = Object.prototype.hasOwnProperty.call(keyOrder, aKey) ? keyOrder[aKey] : 999;
    var bPriority = Object.prototype.hasOwnProperty.call(keyOrder, bKey) ? keyOrder[bKey] : 999;
    if (aPriority !== bPriority) return aPriority - bPriority;

    return readNumber(a.getAttribute('data-look-order'), 0) - readNumber(b.getAttribute('data-look-order'), 0);
  }

  function revealElements(root) {
    var targets = toArray(root.querySelectorAll('.nw-reveal'));
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -10% 0px'
      }
    );

    targets.forEach(function (node) {
      observer.observe(node);
    });
  }

  function animateCount(metric) {
    var target = readNumber(metric.getAttribute('data-count-target'), 0);
    var suffix = metric.getAttribute('data-count-suffix') || '';
    var valueNode = metric.querySelector('[data-count-value]');
    if (!valueNode || !target) return;

    var duration = 900;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);

      valueNode.textContent = current.toLocaleString() + suffix;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }

  function initCountUp(root) {
    var group = root.querySelector('[data-count-group]');
    if (!group) return;

    var metrics = toArray(group.querySelectorAll('[data-count-up]'));
    if (!metrics.length) return;

    if (!('IntersectionObserver' in window)) {
      metrics.forEach(animateCount);
      return;
    }

    var started = false;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || started) return;
          started = true;
          metrics.forEach(animateCount);
          observer.disconnect();
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(group);
  }

  function initProgressReveal(root) {
    var cards = toArray(root.querySelectorAll('[data-look-card]'));
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('is-ready');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-ready');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.28,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function initTryOn(root) {
    var tryOnRoot = root.querySelector('[data-tryon-root]');
    if (!tryOnRoot) return;

    var mainImage = tryOnRoot.querySelector('[data-tryon-main]');
    var options = toArray(tryOnRoot.querySelectorAll('[data-tryon-option]'));
    var hotspots = toArray(tryOnRoot.querySelectorAll('[data-tryon-hotspot]'));
    var hintNode = root.querySelector('[data-tryon-hint]');
    var viewerNode = tryOnRoot.querySelector('.nw-gap-gallery__media--viewer');
    var prevNode = tryOnRoot.querySelector('[data-tryon-prev]');
    var nextNode = tryOnRoot.querySelector('[data-tryon-next]');
    var mobileLabelNode = tryOnRoot.querySelector('[data-tryon-mobile-label]');
    var ghostNodes = [
      tryOnRoot.querySelector('[data-tryon-ghost="1"]'),
      tryOnRoot.querySelector('[data-tryon-ghost="2"]'),
      tryOnRoot.querySelector('[data-tryon-ghost="3"]')
    ];
    if (!mainImage || !options.length) return;

    var activeKey = '';
    var lockedKey = '';
    var transitionTimer = null;
    var optionMap = {};
    var touchMode = false;
    var touchStartX = 0;
    var touchStartY = 0;

    function isTouchTryOnMode() {
      return window.matchMedia('(hover: none), (pointer: coarse), (max-width: 999px)').matches;
    }

    function optionKey(option) {
      return option.getAttribute('data-tryon-key') || slugify(option.getAttribute('data-tryon-label') || '');
    }

    function optionLabel(option) {
      return option.getAttribute('data-tryon-label') || 'Nightwear I preview';
    }

    function optionSrc(option) {
      var defaultSrc = option.getAttribute('data-tryon-src') || '';
      var mobileSrc = option.getAttribute('data-tryon-mobile-src') || '';
      return touchMode && mobileSrc ? mobileSrc : defaultSrc;
    }

    function getOptionByKey(key) {
      return optionMap[String(key || '').trim()] || null;
    }

    function getOptionIndexByKey(key) {
      var target = String(key || '').trim();
      if (!target) return -1;
      for (var i = 0; i < options.length; i += 1) {
        if (optionKey(options[i]) === target) return i;
      }
      return -1;
    }

    function updateMobileLayers(activeOption) {
      if (!touchMode || !activeOption || !ghostNodes.length) return;
      var activeIndex = options.indexOf(activeOption);
      if (activeIndex < 0) return;

      if (mobileLabelNode) {
        mobileLabelNode.textContent = optionLabel(activeOption);
      }

      var prevOption = options[(activeIndex - 1 + options.length) % options.length];
      var nextOption = options[(activeIndex + 1) % options.length];

      if (ghostNodes[0]) {
        var prevSrc = optionSrc(prevOption) || mainImage.getAttribute('data-tryon-mobile-base') || '';
        if (prevSrc && ghostNodes[0].getAttribute('src') !== prevSrc) {
          ghostNodes[0].setAttribute('src', prevSrc);
        }
      }

      if (ghostNodes[1]) {
        var nextSrc = optionSrc(nextOption) || mainImage.getAttribute('data-tryon-mobile-base') || '';
        if (nextSrc && ghostNodes[1].getAttribute('src') !== nextSrc) {
          ghostNodes[1].setAttribute('src', nextSrc);
        }
      }

      if (ghostNodes[2]) {
        ghostNodes[2].setAttribute('aria-hidden', 'true');
      }
    }

    function applyState(activeButton, direction) {
      if (!activeButton) return;

      var nextSrc = optionSrc(activeButton);
      var nextLabel = optionLabel(activeButton);
      var nextKey = optionKey(activeButton);

      if (!nextSrc) return;

      if (nextSrc !== mainImage.getAttribute('src')) {
        tryOnRoot.classList.add('is-transitioning');
        if (touchMode) {
          tryOnRoot.classList.add('is-transitioning-mobile');
          tryOnRoot.classList.remove('is-transition-next', 'is-transition-prev');
          if (direction === 'next' || direction === 'prev') {
            tryOnRoot.classList.add('is-transition-' + direction);
          }
        }
        mainImage.setAttribute('src', nextSrc);
        window.clearTimeout(transitionTimer);
        transitionTimer = window.setTimeout(function () {
          tryOnRoot.classList.remove('is-transitioning');
          tryOnRoot.classList.remove('is-transitioning-mobile', 'is-transition-next', 'is-transition-prev');
        }, 180);
      }

      mainImage.setAttribute('alt', nextLabel + ' preview');
      activeKey = nextKey;

      options.forEach(function (option) {
        var optionKey =
          option.getAttribute('data-tryon-key') || slugify(option.getAttribute('data-tryon-label') || '');
        var isActive = optionKey === activeKey;
        var isLocked = lockedKey && optionKey === lockedKey;

        option.classList.toggle('is-active', isActive);
        option.classList.toggle('is-locked', !!isLocked);
        option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      hotspots.forEach(function (hotspot) {
        var hotspotKey =
          hotspot.getAttribute('data-tryon-key') || slugify(hotspot.getAttribute('aria-label') || '');
        hotspot.classList.toggle('is-active', hotspotKey === activeKey);
        hotspot.classList.toggle('is-locked', !!lockedKey && hotspotKey === lockedKey);
      });

      updateMobileLayers(activeButton);
    }

    function activateByKey(key, shouldLock, direction) {
      var targetKey = String(key || '').trim();
      if (!targetKey) return;

      var option = getOptionByKey(targetKey);
      if (!option) return;

      if (shouldLock) {
        lockedKey = targetKey;
      }

      applyState(option, direction);
    }

    function activateByIndex(index, direction) {
      if (!options.length) return;
      var total = options.length;
      var normalized = ((index % total) + total) % total;
      var option = options[normalized];
      lockedKey = '';
      applyState(option, direction);
    }

    function stepBy(delta) {
      if (!options.length) return;
      var currentIndex = getOptionIndexByKey(activeKey);
      if (currentIndex < 0) currentIndex = 0;
      activateByIndex(currentIndex + delta, delta > 0 ? 'next' : 'prev');
    }

    function syncModeUI() {
      touchMode = isTouchTryOnMode();
      tryOnRoot.classList.toggle('is-touch-mode', touchMode);

      var mobileBaseSrc = mainImage.getAttribute('data-tryon-mobile-base') || '';
      if (hintNode) {
        var defaultHint = hintNode.getAttribute('data-default-hint') || hintNode.textContent || '';
        if (!hintNode.hasAttribute('data-default-hint')) {
          hintNode.setAttribute('data-default-hint', defaultHint);
        }
        hintNode.textContent = touchMode
          ? 'Use arrows or swipe to rotate through each look on Astra.'
          : defaultHint;
      }

      if (touchMode) {
        lockedKey = '';
        if (mobileBaseSrc && !activeKey) {
          mainImage.setAttribute('src', mobileBaseSrc);
        }
      }

      if (activeKey && getOptionByKey(activeKey)) {
        applyState(getOptionByKey(activeKey));
      } else if (options[0]) {
        applyState(options[0]);
      }
    }

    options.forEach(function (option) {
      var key = optionKey(option);
      if (key) {
        optionMap[key] = option;
      }

      var desktopSrc = option.getAttribute('data-tryon-src');
      if (desktopSrc) {
        new Image().src = desktopSrc;
      }
      var mobileSrc = option.getAttribute('data-tryon-mobile-src');
      if (mobileSrc) {
        new Image().src = mobileSrc;
      }

      option.addEventListener('pointerenter', function () {
        if (touchMode || lockedKey) return;
        applyState(option);
      });

      option.addEventListener('focus', function () {
        if (touchMode || lockedKey) return;
        applyState(option);
      });

      option.addEventListener('click', function (event) {
        event.preventDefault();
        if (touchMode) {
          lockedKey = '';
          applyState(option);
          return;
        }
        activateByKey(key, true);
      });
    });

    hotspots.forEach(function (hotspot) {
      var hotspotKey = hotspot.getAttribute('data-tryon-key') || '';
      if (!hotspotKey) return;

      hotspot.addEventListener('pointerenter', function () {
        if (touchMode || lockedKey) return;
        activateByKey(hotspotKey, false);
      });

      hotspot.addEventListener('focus', function () {
        if (touchMode || lockedKey) return;
        activateByKey(hotspotKey, false);
      });

      hotspot.addEventListener('click', function (event) {
        event.preventDefault();
        activateByKey(hotspotKey, true);
      });
    });

    if (prevNode) {
      prevNode.addEventListener('click', function (event) {
        event.preventDefault();
        if (!touchMode) return;
        stepBy(-1);
      });
    }

    if (nextNode) {
      nextNode.addEventListener('click', function (event) {
        event.preventDefault();
        if (!touchMode) return;
        stepBy(1);
      });
    }

    if (viewerNode) {
      viewerNode.addEventListener(
        'touchstart',
        function (event) {
          if (!touchMode || !event.touches || !event.touches.length) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      viewerNode.addEventListener(
        'touchend',
        function (event) {
          if (!touchMode || !event.changedTouches || !event.changedTouches.length) return;
          var touch = event.changedTouches[0];
          var deltaX = touch.clientX - touchStartX;
          var deltaY = touch.clientY - touchStartY;
          if (Math.abs(deltaX) < 36 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;
          stepBy(deltaX < 0 ? 1 : -1);
        },
        { passive: true }
      );
    }

    syncModeUI();
    window.addEventListener('resize', syncModeUI);
    window.addEventListener('orientationchange', syncModeUI);
  }

  function readCardPayload(card) {
    var imageNode = card.querySelector('.nw-look__image--base');
    var noteNode = card.querySelector('.nw-look__note');
    var selectNode = card.querySelector('[data-look-select]');

    return {
      key: card.getAttribute('data-look-key') || '',
      title: card.getAttribute('data-look-title') || '',
      status: card.getAttribute('data-look-status') || '',
      copy: card.getAttribute('data-look-copy') || '',
      url: card.getAttribute('data-look-url') || '',
      progress: readProgress(card),
      votes: readVotes(card),
      note: noteNode ? noteNode.textContent : '',
      imageSrc: imageNode ? imageNode.getAttribute('src') || '' : '',
      imageAlt: imageNode ? imageNode.getAttribute('alt') || '' : '',
      selectLabel: selectNode ? selectNode.textContent : ''
    };
  }

  function writeCardPayload(card, payload) {
    if (!card || !payload) return;

    card.setAttribute('data-look-key', payload.key || '');
    card.setAttribute('data-look-title', payload.title || '');
    card.setAttribute('data-look-status', payload.status || '');
    card.setAttribute('data-look-copy', payload.copy || '');
    card.setAttribute('data-look-url', payload.url || '');

    var titleNode = card.querySelector('.nw-look__title');
    if (titleNode) titleNode.textContent = payload.title || '';

    var statusNode = card.querySelector('.nw-look__status');
    if (statusNode) statusNode.textContent = payload.status || '';

    var teaseNode = card.querySelector('.nw-look__tease');
    if (teaseNode) teaseNode.textContent = payload.copy || '';

    var noteNode = card.querySelector('.nw-look__note');
    if (noteNode) noteNode.textContent = payload.note || '';

    var selectNode = card.querySelector('[data-look-select]');
    if (selectNode && payload.selectLabel) {
      selectNode.textContent = payload.selectLabel;
    }

    var imageNode = card.querySelector('.nw-look__image--base');
    if (imageNode && payload.imageSrc) {
      imageNode.setAttribute('src', payload.imageSrc);
      imageNode.setAttribute('srcset', payload.imageSrc);
      imageNode.setAttribute('alt', payload.imageAlt || payload.title || '');
    }

    setProgress(card, payload.progress || 0);
    setVotes(card, payload.votes || 0);
  }

  function applyRankings(root, cards) {
    var leaderKey =
      (root.getAttribute('data-live-leader-key') || root.getAttribute('data-initial-leader-key') || '').trim();
    var sorted = cards.slice().sort(function (a, b) {
      return compareRankedCards(a, b, leaderKey);
    });

    var boardMain = root.querySelector('.nw-board__main');
    var tryOnSection = boardMain ? boardMain.querySelector('.nw-gap-gallery') : null;
    var challengerRail = root.querySelector('.nw-challengers');
    var leadCard = boardMain ? boardMain.querySelector('.nw-look--lead[data-look-card]') : null;
    if (!leadCard) {
      leadCard = root.querySelector('.nw-look--lead[data-look-card]');
    }

    // Keep layout deterministic: #1 lead card must sit above Astra try-on in the main board column.
    if (boardMain && leadCard) {
      if (tryOnSection) {
        boardMain.insertBefore(leadCard, tryOnSection);
      } else if (leadCard.parentElement !== boardMain) {
        boardMain.insertBefore(leadCard, boardMain.firstChild);
      }
    }

    var leadingCard = sorted[0] || null;

    // Keep the large "lead" layout fixed, but swap payloads so #1 always appears in the large card.
    if (leadCard && leadingCard && leadCard !== leadingCard) {
      var leadPayload = readCardPayload(leadCard);
      var winnerPayload = readCardPayload(leadingCard);
      writeCardPayload(leadCard, winnerPayload);
      writeCardPayload(leadingCard, leadPayload);

      sorted = cards.slice().sort(function (a, b) {
        return compareRankedCards(a, b, leaderKey);
      });
      leadingCard = sorted[0] || leadCard;
    }

    if (challengerRail && leadCard) {
      sorted
        .filter(function (card) {
          return card !== leadCard;
        })
        .forEach(function (card) {
          challengerRail.appendChild(card);
        });
    }

    sorted.forEach(function (card, index) {
      var rank = index + 1;
      card.setAttribute('data-look-rank', String(rank));

      var rankNode = card.querySelector('[data-rank-label]');
      if (rankNode) {
        rankNode.textContent = '#' + rank;
      }

      card.classList.toggle('is-leading', rank === 1);
    });

    return sorted[0] || null;
  }

  function syncLeader(root, leadingCard) {
    if (!leadingCard) return;

    var cards = toArray(root.querySelectorAll('[data-look-card]'));
    var hasSignals = cards.some(function (card) {
      return readProgress(card) > 0;
    });

    cards.forEach(function (card) {
      var shareNode = card.querySelector('[data-progress-share]');
      var emptyNode = card.querySelector('[data-progress-empty]');
      if (shareNode) shareNode.hidden = !hasSignals;
      if (emptyNode) emptyNode.hidden = hasSignals;
    });

    var liveLeader = root.querySelector('[data-live-leader]');
    var liveProgress = root.querySelector('[data-live-progress]');
    var liveShare = root.querySelector('[data-live-leader-share]');
    var liveEmpty = root.querySelector('[data-live-leader-empty]');

    if (liveLeader) {
      liveLeader.textContent = hasSignals
        ? leadingCard.getAttribute('data-look-title') || 'Founders favorite'
        : 'No leader yet';
    }

    if (liveProgress) {
      liveProgress.textContent = hasSignals ? String(readProgress(leadingCard)) : '0';
    }

    if (liveShare) liveShare.hidden = !hasSignals;
    if (liveEmpty) liveEmpty.hidden = hasSignals;
  }

  function animateImageToLightbox(card, modalImage) {
    if (!card || !modalImage) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sourceFrame = card.querySelector('.nw-look__media');
    if (!sourceFrame) return;

    var hoverImage = card.querySelector('.nw-look__image--hover');
    var baseImage = card.querySelector('.nw-look__image--base');
    var sourceSrc =
      (hoverImage && (hoverImage.currentSrc || hoverImage.getAttribute('src'))) ||
      (baseImage && (baseImage.currentSrc || baseImage.getAttribute('src')));

    if (!sourceSrc) return;

    var startRect = sourceFrame.getBoundingClientRect();
    if (!startRect.width || !startRect.height) return;

    var ghost = document.createElement('img');
    ghost.src = sourceSrc;
    ghost.alt = '';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.left = startRect.left + 'px';
    ghost.style.top = startRect.top + 'px';
    ghost.style.width = startRect.width + 'px';
    ghost.style.height = startRect.height + 'px';
    ghost.style.opacity = '0.94';
    ghost.style.pointerEvents = 'none';
    ghost.style.position = 'fixed';
    ghost.style.transform = 'translateZ(0)';
    ghost.style.transition = 'all 460ms cubic-bezier(0.2, 0.72, 0.2, 1)';
    ghost.style.zIndex = '90';

    document.body.appendChild(ghost);

    modalImage.style.opacity = '0';

    window.requestAnimationFrame(function () {
      var endRect = modalImage.getBoundingClientRect();
      if (!endRect.width || !endRect.height) {
        ghost.remove();
        modalImage.style.opacity = '';
        return;
      }

      ghost.style.left = endRect.left + 'px';
      ghost.style.top = endRect.top + 'px';
      ghost.style.width = endRect.width + 'px';
      ghost.style.height = endRect.height + 'px';
      ghost.style.opacity = '0.28';

      window.setTimeout(function () {
        modalImage.style.opacity = '';
      }, 220);

      window.setTimeout(function () {
        ghost.remove();
      }, 500);
    });
  }

  function initLightbox(root) {
    var modal = root.querySelector('[data-lightbox]');
    if (!modal) {
      return {
        open: function () {},
        close: function () {},
        setCard: function () {},
        isOpen: function () {
          return false;
        }
      };
    }

    var closeNodes = toArray(modal.querySelectorAll('[data-lightbox-close]'));
    var titleNode = modal.querySelector('[data-lightbox-title]');
    var choiceNode = modal.querySelector('[data-lightbox-choice]');
    var tagInput = modal.querySelector('[data-lightbox-tags]');
    var imageNode = modal.querySelector('[data-lightbox-image]');
    var emailNode = modal.querySelector('[data-lightbox-email]');
    var formNode = modal.querySelector('[data-lightbox-form]') || modal.querySelector('form');
    var submitNode = modal.querySelector('[data-lightbox-submit]');
    var successNode = modal.querySelector('[data-lightbox-success]');
    var statusNode = modal.querySelector('[data-lightbox-status]');
    var voteEndpoint = root.getAttribute('data-vote-endpoint') || '';
    var voteSource = root.getAttribute('data-vote-source') || 'nightwear_i';
    var submitting = false;

    var activeCard = null;

    function setCard(card) {
      if (!card) return;
      activeCard = card;

      var title = card.getAttribute('data-look-title') || 'Selected form';
      var key = card.getAttribute('data-look-key') || slugify(title);

      if (titleNode) {
        titleNode.textContent = "Enter Founder's Circle for " + title;
      }

      if (choiceNode) {
        choiceNode.textContent = title + ' selected. You will receive private updates as this release progresses.';
      }

      if (successNode) {
        successNode.textContent =
          'You are in. Your Nightwear I preference has been recorded, you voted for ' + title + '.';
      }

      if (statusNode) {
        statusNode.textContent = '';
        statusNode.hidden = true;
        statusNode.classList.remove('is-success', 'is-error');
      }

      if (tagInput) {
        var baseTags = tagInput.getAttribute('data-base-tags') || 'list_founders_circle,nightwear_i_voter';
        tagInput.value = baseTags + ',vote_nightwear_i_' + key;
      }

      if (imageNode) {
        var transparentImage = card.querySelector('.nw-look__image--hover');
        var fallbackImage = card.querySelector('.nw-look__image--base');
        var src =
          (transparentImage && (transparentImage.currentSrc || transparentImage.getAttribute('src'))) ||
          (fallbackImage && (fallbackImage.currentSrc || fallbackImage.getAttribute('src')));

        if (src) {
          imageNode.setAttribute('src', src);
          imageNode.setAttribute('alt', title);
        }
      }
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function open(card, options) {
      var shouldAnimate = !(options && options.animate === false);
      var shouldFocus = !(options && options.focus === false);

      if (card) {
        setCard(card);
      }

      if (!activeCard) return;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      if (imageNode && shouldAnimate) {
        animateImageToLightbox(activeCard, imageNode);
      }

      window.setTimeout(function () {
        if (!shouldFocus) return;
        if (emailNode) {
          emailNode.focus();
        }
      }, 120);
    }

    closeNodes.forEach(function (node) {
      node.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!modal.classList.contains('is-open')) return;
      close();
    });

    if (formNode) {
      formNode.setAttribute('novalidate', 'novalidate');
      formNode.setAttribute('action', '#');

      var runSubmission = function () {
        if (submitting) return;
        if (!activeCard) return;

        var selectedTitle = activeCard.getAttribute('data-look-title') || 'your selected set';
        var selectedKey = activeCard.getAttribute('data-look-key') || slugify(selectedTitle);
        var emailValue = emailNode && emailNode.value ? String(emailNode.value).trim().toLowerCase() : '';
        var attribution = collectAttribution(voteSource);
        var conversionId = generateConversionId(selectedKey);
        var trackingBase = {
          vote_source: voteSource,
          selected_key: selectedKey,
          selected_title: selectedTitle,
          conversion_id: conversionId
        };

        if (attribution.utm_source) trackingBase.utm_source = attribution.utm_source;
        if (attribution.utm_medium) trackingBase.utm_medium = attribution.utm_medium;
        if (attribution.utm_campaign) trackingBase.utm_campaign = attribution.utm_campaign;
        if (attribution.utm_content) trackingBase.utm_content = attribution.utm_content;
        if (attribution.utm_term) trackingBase.utm_term = attribution.utm_term;
        if (attribution.twclid) trackingBase.twclid = attribution.twclid;

        try {
          window.sessionStorage.setItem(
            'kiki_nightwear_selected_set',
            JSON.stringify({
              key: selectedKey,
              title: selectedTitle
            })
          );
        } catch (error) {
          return null;
        }

        if (!emailValue) {
          if (statusNode) {
            statusNode.textContent = 'Please enter your email to continue.';
            statusNode.hidden = false;
            statusNode.classList.remove('is-success');
            statusNode.classList.add('is-error');
          }
          return;
        }

        submitting = true;
        if (submitNode) {
          submitNode.disabled = true;
          submitNode.setAttribute('aria-busy', 'true');
        }
        if (statusNode) {
          statusNode.hidden = true;
          statusNode.textContent = '';
          statusNode.classList.remove('is-success', 'is-error');
        }

        var showSuccess = function (text) {
          if (statusNode) {
            statusNode.textContent = text;
            statusNode.hidden = false;
            statusNode.classList.remove('is-error');
            statusNode.classList.add('is-success');
          }
          if (successNode) {
            successNode.textContent = text;
          }
        };

        var showError = function (text) {
          if (statusNode) {
            statusNode.textContent = text;
            statusNode.hidden = false;
            statusNode.classList.remove('is-success');
            statusNode.classList.add('is-error');
          }
        };

        var submitViaLegacyForm = function () {
          var formData = new window.FormData(formNode);
          var submitAction = formNode.getAttribute('action') || '/contact';
          var submitUrl = submitAction.split('#')[0] || '/contact';

          return fetch(submitUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
            headers: {
              Accept: 'text/html',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
            .then(function (response) {
              return response.text().then(function (html) {
                return { response: response, html: html };
              });
            })
            .then(function (result) {
              var response = result.response;
              var html = result.html || '';
              var cfMitigated = response.headers && response.headers.get('cf-mitigated') === 'challenge';

              if (response.url && response.url.indexOf('/challenge') !== -1) {
                throw new Error('challenge_required');
              }

              var parser = new window.DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var returnedForm = doc.querySelector('#NightwearLightboxForm');
              var hasServerSuccess = returnedForm && returnedForm.querySelector('[data-lightbox-success]');
              var serverError = returnedForm && returnedForm.querySelector('.nw-lightbox__error');
              var redirectSuccess = response.redirected && (!response.url || response.url.indexOf('/challenge') === -1);
              var serverErrorText = '';
              var duplicateEmail = false;
              var rawText = String(html || '').replace(/\s+/g, ' ').toLowerCase();
              var challengeDetected =
                cfMitigated ||
                rawText.indexOf('just a moment') !== -1 ||
                rawText.indexOf('challenge-platform') !== -1 ||
                rawText.indexOf('cf_chl_') !== -1;

              if (challengeDetected) {
                throw new Error('challenge_required');
              }

              if (serverError) {
                serverErrorText = serverError.textContent.replace(/\s+/g, ' ').trim();
                duplicateEmail =
                  /already been taken/i.test(serverErrorText) ||
                  /already exists/i.test(serverErrorText) ||
                  /taken/i.test(serverErrorText);
              }

              if (!duplicateEmail) {
                duplicateEmail =
                  rawText.indexOf('already been taken') !== -1 ||
                  rawText.indexOf('has already been taken') !== -1 ||
                  rawText.indexOf('already exists') !== -1 ||
                  rawText.indexOf('email has already') !== -1 ||
                  rawText.indexOf('email is already') !== -1 ||
                  rawText.indexOf('customer already exists') !== -1;
              }

              if (duplicateEmail) {
                showSuccess(
                  "You're already on our email list. We could not verify a new vote with this fallback path."
                );
                emitTrackingEvent('kiki_nightwear_vote_existing', Object.assign({ status: 'already_exists' }, trackingBase));
                return;
              }

              if (!response.ok || serverError) {
                var errorText = 'Unable to submit right now. Please try again.';
                if (serverErrorText) {
                  errorText = serverErrorText || errorText;
                }
                showError(errorText);
                emitTrackingEvent(
                  'kiki_nightwear_vote_error',
                  Object.assign({ status: 'legacy_error', error_message: clampString(errorText, 240) }, trackingBase)
                );
                return;
              }

              if (hasServerSuccess || redirectSuccess) {
                showSuccess(
                  'You are in. Your Nightwear I preference has been recorded, you voted for ' +
                    selectedTitle +
                    '.'
                );
                formNode.reset();
                emitTrackingEvent('kiki_nightwear_vote_success', Object.assign({ status: 'legacy_ok' }, trackingBase));
                window.setTimeout(markLeadSuccessInUrl, 90);
              }
            });
        };

        var submitViaProxy = function () {
          if (!voteEndpoint) {
            return Promise.reject(new Error('proxy_missing'));
          }

          var proxyForm = new URLSearchParams();
          proxyForm.set('email', emailValue);
          proxyForm.set('set_key', selectedKey);
          proxyForm.set('set_title', selectedTitle);
          proxyForm.set('source', voteSource);
          proxyForm.set('x_conversion_id', conversionId);
          Object.keys(attribution).forEach(function (key) {
            var value = clampString(attribution[key], 900);
            if (!value || key === 'source') return;
            proxyForm.set(key, value);
          });

          return fetch(voteEndpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              // App proxy forwards form-encoded payloads more reliably than JSON bodies.
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: proxyForm.toString()
          })
            .then(function (response) {
              return response.text().then(function (text) {
                return { response: response, text: text };
              });
            })
            .then(function (result) {
              var response = result.response;
              var text = result.text || '';
              var payload = null;

              try {
                payload = JSON.parse(text);
              } catch (error) {
                payload = null;
              }

              if (!response.ok) {
                var backendMessage = payload && payload.message ? String(payload.message) : '';
                if (response.status === 404) throw new Error('proxy_not_found');
                if (response.status === 401 || response.status === 403) throw new Error('proxy_forbidden');
                if (backendMessage) throw new Error('proxy_error:' + backendMessage);
                throw new Error('proxy_request_failed');
              }

              if (!payload || !payload.status) {
                throw new Error('proxy_request_failed');
              }

              if (payload.status === 'already_voted') {
                var alreadySet = payload.voted_for || selectedTitle;
                showSuccess(
                  "You're already in Founder\u2019s Circle. We already have your vote for " + alreadySet + '.'
                );
                emitTrackingEvent(
                  'kiki_nightwear_vote_existing',
                  Object.assign({ status: 'already_voted', voted_for: alreadySet }, trackingBase)
                );
                return;
              }

              if (payload.status === 'ok') {
                var votedFor = payload.voted_for || selectedTitle;
                showSuccess(
                  'You are in. Your Nightwear I preference has been recorded, you voted for ' + votedFor + '.'
                );
                formNode.reset();
                emitTrackingEvent(
                  'kiki_nightwear_vote_success',
                  Object.assign({ status: 'ok', voted_for: votedFor }, trackingBase)
                );
                window.setTimeout(markLeadSuccessInUrl, 90);
                return;
              }

              throw new Error(payload.message || 'proxy_unexpected_status');
            });
        };

        submitViaProxy()
          .catch(function (proxyError) {
            var fallbackText = 'Unable to submit right now. Please try again.';
            var shouldTryLegacy =
              proxyError &&
              (proxyError.message === 'proxy_not_found' || proxyError.message === 'proxy_forbidden');

            if (proxyError && proxyError.message === 'proxy_not_found') {
              fallbackText =
                'Vote service endpoint was not found (/apps/nightwear-vote). Configure app proxy route, then retry.';
            } else if (proxyError && proxyError.message === 'proxy_forbidden') {
              fallbackText =
                'Vote service is not authorized yet. Confirm app proxy install and permissions, then retry.';
            } else if (
              proxyError &&
              typeof proxyError.message === 'string' &&
              proxyError.message.indexOf('proxy_error:') === 0
            ) {
              var proxyDetail = proxyError.message.replace('proxy_error:', '').trim();
              fallbackText = proxyDetail
                ? 'Vote service error: ' + proxyDetail
                : 'Vote service returned an unknown error.';
              shouldTryLegacy = false;
            } else if (proxyError && proxyError.message === 'proxy_request_failed') {
              fallbackText = 'Vote service did not return a valid response. Please try again.';
              shouldTryLegacy = false;
            } else if (proxyError && proxyError.message === 'proxy_missing') {
              fallbackText =
                'Vote service endpoint is missing. Configure /apps/nightwear-vote in app proxy settings.';
              shouldTryLegacy = false;
            }

            if (!shouldTryLegacy) {
              showError(fallbackText);
              emitTrackingEvent(
                'kiki_nightwear_vote_error',
                Object.assign(
                  { status: 'proxy_error', error_message: clampString(fallbackText, 240) },
                  trackingBase
                )
              );
              return Promise.resolve();
            }

            return submitViaLegacyForm().catch(function (legacyError) {
              if (legacyError && legacyError.message === 'challenge_required') {
                fallbackText =
                  'Security check triggered on fallback submit. Please retry once. If it keeps happening, the vote endpoint must be configured in Shopify app proxy.';
              }
              showError(fallbackText);
              emitTrackingEvent(
                'kiki_nightwear_vote_error',
                Object.assign(
                  { status: 'legacy_fallback_error', error_message: clampString(fallbackText, 240) },
                  trackingBase
                )
              );
            });
          })
          .finally(function () {
            submitting = false;
            if (submitNode) {
              submitNode.disabled = false;
              submitNode.removeAttribute('aria-busy');
            }
          });
      };

      var handleSubmit = function (event) {
        event.preventDefault();
        event.stopPropagation();
        runSubmission();
        return false;
      };

      formNode.addEventListener('submit', handleSubmit, true);
      formNode.addEventListener('submit', handleSubmit);

      if (submitNode) {
        submitNode.addEventListener('click', function (event) {
          event.preventDefault();
          runSubmission();
        });
      }

      if (emailNode) {
        emailNode.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          runSubmission();
        });
      }
    }

    return {
      open: open,
      close: close,
      setCard: setCard,
      isOpen: function () {
        return modal.classList.contains('is-open');
      }
    };
  }

  function initSelection(root) {
    var cards = toArray(root.querySelectorAll('[data-look-card]'));
    if (!cards.length) return;
    var voteSource = root.getAttribute('data-vote-source') || 'nightwear_i';

    cards.forEach(function (card, index) {
      if (!card.hasAttribute('data-look-order')) {
        card.setAttribute('data-look-order', String(index));
      }
    });

    var dockCopy = root.querySelector('[data-selection-copy]');
    var dockLink = root.querySelector('[data-selection-link]');
    var lightbox = initLightbox(root);
    var activeCard = null;
    var persistedSelection = null;

    try {
      var saved = window.sessionStorage.getItem('kiki_nightwear_selected_set');
      if (saved) {
        persistedSelection = JSON.parse(saved);
      }
    } catch (error) {
      persistedSelection = null;
    }

    var leadingCard = applyRankings(root, cards);
    syncLeader(root, leadingCard);

    function selectCard(card, options) {
      activeCard = card;

      cards.forEach(function (item) {
        var selected = item === card;
        item.classList.toggle('is-active', selected);

        var selectButton = item.querySelector('[data-look-select]');
        if (selectButton) {
          selectButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
        }
      });

      var title = card.getAttribute('data-look-title') || 'This set';
      var status = card.getAttribute('data-look-status') || 'Selected';

      if (dockCopy) {
        dockCopy.textContent = title + ' selected. ' + status + '.';
      }

      if (dockLink) {
        dockLink.setAttribute('href', '#');
      }

      lightbox.setCard(card);

      if (options && options.track === false) return;

      var selectedTitle = card.getAttribute('data-look-title') || 'Selected set';
      var selectedKey = card.getAttribute('data-look-key') || slugify(selectedTitle);
      var attribution = collectAttribution(voteSource);
      var trackingPayload = {
        vote_source: voteSource,
        selected_key: selectedKey,
        selected_title: selectedTitle
      };

      if (attribution.utm_source) trackingPayload.utm_source = attribution.utm_source;
      if (attribution.utm_medium) trackingPayload.utm_medium = attribution.utm_medium;
      if (attribution.utm_campaign) trackingPayload.utm_campaign = attribution.utm_campaign;
      if (attribution.utm_content) trackingPayload.utm_content = attribution.utm_content;
      if (attribution.utm_term) trackingPayload.utm_term = attribution.utm_term;
      if (attribution.twclid) trackingPayload.twclid = attribution.twclid;

      emitTrackingEvent('kiki_nightwear_selected_set', trackingPayload);
    }

    cards.forEach(function (card) {
      var selectButton = card.querySelector('[data-look-select]');
      if (selectButton) {
        selectButton.addEventListener('click', function () {
          selectCard(card, { track: true });
          lightbox.open(card);
        });
      }

      card.addEventListener('click', function (event) {
        if (event.target.closest('a, button, input, label, textarea, select')) return;
        selectCard(card, { track: true });
      });

      card.addEventListener('mousemove', function (event) {
        if (window.matchMedia('(max-width: 999px)').matches) return;
        if (card.classList.contains('nw-look--lead')) return;

        var rect = card.getBoundingClientRect();
        var relativeX = (event.clientX - rect.left) / rect.width;
        var relativeY = (event.clientY - rect.top) / rect.height;
        var rotateY = (relativeX - 0.5) * 2.8;
        var rotateX = (0.5 - relativeY) * 2.4;

        card.style.transform =
          'translateY(-2px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg)';
      });

      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });

    if (dockLink) {
      dockLink.addEventListener('click', function (event) {
        event.preventDefault();
        if (!activeCard) return;
        lightbox.open(activeCard);
      });
    }

    var initialCard = leadingCard || cards[0];
    if (persistedSelection && persistedSelection.key) {
      var matchedCard = cards.find(function (card) {
        return card.getAttribute('data-look-key') === persistedSelection.key;
      });
      if (matchedCard) {
        initialCard = matchedCard;
      }
    }

    selectCard(initialCard, { track: false });

    var shouldShowQuerySuccess = hasLeadSuccessInUrl();

    if (root.querySelector('[data-lightbox-success]') || root.querySelector('.nw-lightbox__error') || shouldShowQuerySuccess) {
      lightbox.open(activeCard, { animate: false, focus: false });
    }

    if (shouldShowQuerySuccess && activeCard) {
      var selectedTitle = activeCard.getAttribute('data-look-title') || 'your selected set';
      var successText =
        'You are in. Your Nightwear I preference has been recorded, you voted for ' + selectedTitle + '.';
      var statusNode = root.querySelector('[data-lightbox-status]');
      var successNode = root.querySelector('[data-lightbox-success]');

      if (statusNode) {
        statusNode.textContent = successText;
        statusNode.hidden = false;
        statusNode.classList.remove('is-error');
        statusNode.classList.add('is-success');
      }

      if (successNode) {
        successNode.textContent = successText;
      }

      window.setTimeout(clearLeadSuccessQueryFromUrl, 1800);
    }
  }

  function writeMetricValue(metricNode, value) {
    var suffix = metricNode.getAttribute('data-count-suffix') || '';
    var safe = Math.max(0, Math.round(readNumber(value, 0)));
    metricNode.setAttribute('data-count-target', String(safe));

    var valueNode = metricNode.querySelector('[data-count-value]');
    if (valueNode) {
      valueNode.textContent = safe.toLocaleString() + suffix;
    }
  }

  function applyLiveStats(root, payload) {
    if (!payload || typeof payload !== 'object') return;

    var metricMap = {
      founders_total: payload.founders_total,
      black_share: payload.black_share,
      decision_window_hours: payload.decision_window_hours
    };

    Object.keys(metricMap).forEach(function (key) {
      if (!Number.isFinite(readNumber(metricMap[key], NaN))) return;
      var metricNode = root.querySelector('[data-live-metric="' + key + '"]');
      if (!metricNode) return;
      writeMetricValue(metricNode, metricMap[key]);
    });

    if (payload.next_update) {
      var nextUpdateNode = root.querySelector('[data-next-update]');
      if (nextUpdateNode) {
        nextUpdateNode.textContent = 'Next scheduled update: ' + payload.next_update;
      }
    }

    if (payload.leader && payload.leader.key) {
      root.setAttribute('data-live-leader-key', String(payload.leader.key));
    }

    var cards = toArray(root.querySelectorAll('[data-look-card]'));
    if (payload.looks && typeof payload.looks === 'object' && cards.length) {
      cards.forEach(function (card) {
        var key = card.getAttribute('data-look-key');
        if (!key) return;

        var nextProgress = payload.looks[key];
        if (!Number.isFinite(readNumber(nextProgress, NaN))) return;
        setProgress(card, nextProgress);

        if (payload.votes && typeof payload.votes === 'object') {
          var nextVotes = payload.votes[key];
          if (Number.isFinite(readNumber(nextVotes, NaN))) {
            setVotes(card, nextVotes);
          }
        }
      });

      var leadingCard = applyRankings(root, cards);
      syncLeader(root, leadingCard);
    }
  }

  function initLiveFeed(root) {
    var endpoint = (root.getAttribute('data-stats-endpoint') || '').trim();
    var voteEndpoint = (root.getAttribute('data-vote-endpoint') || '').trim();
    var fallbackEndpoint = voteEndpoint ? voteEndpoint.replace(/\/+$/, '') + '/stats' : '';
    var endpoints = [];

    if (endpoint) {
      endpoints.push(endpoint);
    }

    if (fallbackEndpoint && endpoints.indexOf(fallbackEndpoint) === -1) {
      endpoints.push(fallbackEndpoint);
    }

    if (!endpoints.length) return;

    var refreshSeconds = readNumber(root.getAttribute('data-stats-refresh'), 45);
    refreshSeconds = Math.max(15, refreshSeconds);
    var activeEndpointIndex = 0;

    function requestStats(index) {
      var current = endpoints[index];
      if (!current) {
        return Promise.reject(new Error('missing_stats_endpoint'));
      }

      return fetch(current, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Stats request failed');
          return response.json();
        })
        .then(function (payload) {
          activeEndpointIndex = index;
          return payload;
        })
        .catch(function (error) {
          if (index + 1 < endpoints.length) {
            return requestStats(index + 1);
          }
          throw error;
        });
    }

    function refreshStats() {
      requestStats(activeEndpointIndex)
        .then(function (payload) {
          applyLiveStats(root, payload);
        })
        .catch(function () {
          return null;
        });
    }

    refreshStats();
    window.setInterval(refreshStats, refreshSeconds * 1000);
  }

  function initSection(root) {
    if (!root || root.dataset.nightwearBooted === 'true') return;
    root.dataset.nightwearBooted = 'true';
    var voteSource = root.getAttribute('data-vote-source') || 'nightwear_i';
    var pageAttribution = collectAttribution(voteSource);

    emitTrackingEvent(
      'kiki_nightwear_page_view',
      {
        vote_source: voteSource,
        page_path: pageAttribution.page_path || '',
        utm_source: pageAttribution.utm_source || '',
        utm_medium: pageAttribution.utm_medium || '',
        utm_campaign: pageAttribution.utm_campaign || '',
        utm_content: pageAttribution.utm_content || '',
        twclid: pageAttribution.twclid || ''
      }
    );

    revealElements(root);
    initCountUp(root);
    initProgressReveal(root);
    initTryOn(root);
    initSelection(root);
    initLiveFeed(root);
  }

  function boot(target) {
    var roots = target ? [target] : toArray(document.querySelectorAll('[data-nightwear-launch]'));
    roots.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target && event.target.querySelector('[data-nightwear-launch]'));
  });
})();
